export const resultTypes = {
  ROUTE: 0,
  ITEM: 1,
};
